import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Snackbar, Alert } from "@mui/material"
import styles from "../css/Datos.module.css"
import { Grid } from "@mui/system"
import { useEffect, useState } from "react"
import Wait from "../components/Wait"
import Confirmacion from "../components/Conformacion"
import { useAuth } from "../hooks/AuthProvider"
import miAxios from "../api/axios"

export default function Datos(props) {
    const [nombre, setNombre] = useState("")
    const [direccion, setDireccion] = useState("")
    const [telefono, setTelefono] = useState("")
    const [email, setEmail] = useState("")
    const [whatsapp, setWhatsapp] = useState("")
    const [facebook, setFacebook] = useState("")
    const [instagram, setInstagram] = useState("")
    const [tiktok, setTiktok] = useState("")
    const [openConfirmacion, setOpenConfirmacion] = useState(false)

    const [procesando, setProcesando] = useState(false)
    const [mensaje, setMensaje] = useState("")

    const user = useAuth()
    const axios = miAxios(user.handleLogout)

    useEffect(() => {
        inicio()
    }, [])

    const inicio = async () => {
        setProcesando(true)

        try {
            const response = await axios.get("/proveedores/datos-inicio")
            const data = response.data;
            if (data.respuesta == "S") {
                setNombre(data.nombre)
                setDireccion(data.direccion)
                setTelefono(data.telefono)
                setEmail(data.email)
                setWhatsapp(data.whatsapp)
                setFacebook(data.facebook)
                setInstagram(data.instagram)
                setTiktok(data.tiktok)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const handleConfirmar = ()=>{
        if (puedeGrabar()){
            setOpenConfirmacion(true)
        }
    }

    const handleGrabar = () => {
        if (puedeGrabar()){
            grabar();
        }
    }

    const puedeGrabar = () => {
        if (nombre.length == 0) {
            setMensaje("Debe digitar el nombre")
            return false;
        }
        if (telefono.length == 0) {
            setMensaje("Debe digitar el telefono")
            return false;
        }
        if (whatsapp.length == 0) {
            setMensaje("Debe digitar el whatsapp")
            return false;
        }
        if (email.length == 0) {
            setMensaje("Debe digitar el email")
            return false;
        }
        return true
    }

    const grabar = async () => {
        setOpenConfirmacion(false)
        setProcesando(true)

        try {
            const response = await axios.post("/proveedores/datos-grabar", {
                nombre: nombre,
                direccion: direccion,
                telefono: telefono,
                email: email,
                whatsapp: whatsapp,
                facebook: facebook,
                instagram: instagram,
                tiktok: tiktok
            })
            const data = response.data;
            if (data.respuesta == "S") {
                props.cerrar()
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const handleCloseMensaje = () => {
        setMensaje("")
    }

    return <Dialog open={props.open} fullWidth maxWidth="md">
        {
            procesando && (
                <Wait procesando={procesando} />
            )
        }
        {
            openConfirmacion && (
                <Confirmacion
                    open={openConfirmacion}
                    texto="¿Desea actualizar los datos?"
                    cancelar={() => { setOpenConfirmacion(false) }}
                    exito={handleGrabar}
                />
            )
        }
        <Snackbar
            open={mensaje.length == 0 ? false : true}
            autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseMensaje}
        >
            <Alert severity="error" onClose={handleCloseMensaje} variant="filled">{mensaje}</Alert>
        </Snackbar>
        <DialogTitle color="coopinfa">
            Actualizar mis datos
        </DialogTitle>
        <DialogContent>
            <div className={styles.cuerpo}>
                <Grid container spacing={1}>
                    <Grid size={12}>
                        <TextField
                            value={nombre}
                            label="Nombre Comercial"
                            onChange={(event) => { setNombre(event.target.value) }}
                            size="large"
                            fullWidth
                            color="coopinfa"
                            slotProps={{ inputLabel: { shrink: true } }}
                        />
                    </Grid>
                    <Grid size={12}>
                        <TextField
                            value={direccion}
                            label="Dirección"
                            onChange={(event) => { setDireccion(event.target.value) }}
                            size="large"
                            fullWidth
                            multiline
                            rows={2}
                            color="coopinfa"
                            slotProps={{ inputLabel: { shrink: true } }}
                        />
                    </Grid>
                    <Grid size={6}>
                        <TextField
                            value={email}
                            label="E-Mail"
                            onChange={(event) => { setEmail(event.target.value) }}
                            size="large"
                            fullWidth
                            color="coopinfa"
                            slotProps={{ inputLabel: { shrink: true } }}
                        />
                    </Grid>
                    <Grid size={3}>
                        <TextField
                            value={telefono}
                            label="Teléfono"
                            onChange={(event) => { setTelefono(event.target.value) }}
                            size="large"
                            fullWidth
                            color="coopinfa"
                            slotProps={{ inputLabel: { shrink: true } }}
                        />
                    </Grid>
                    <Grid size={3}>
                        <TextField
                            value={whatsapp}
                            label="Whatsapp"
                            onChange={(event) => { setWhatsapp(event.target.value) }}
                            size="large"
                            fullWidth
                            color="coopinfa"
                            slotProps={{ inputLabel: { shrink: true } }}
                        />
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            value={facebook}
                            label="Facebook"
                            onChange={(event) => { setFacebook(event.target.value) }}
                            size="large"
                            fullWidth
                            color="coopinfa"
                            slotProps={{ inputLabel: { shrink: true } }}
                        />
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            value={instagram}
                            label="Instagram"
                            onChange={(event) => { setInstagram(event.target.value) }}
                            size="large"
                            fullWidth
                            color="coopinfa"
                            slotProps={{ inputLabel: { shrink: true } }}
                        />
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            value={tiktok}
                            label="Tiktok"
                            onChange={(event) => { setTiktok(event.target.value) }}
                            size="large"
                            fullWidth
                            color="coopinfa"
                            slotProps={{ inputLabel: { shrink: true } }}
                        />
                    </Grid>
                </Grid>
            </div>
        </DialogContent>
        <DialogActions>
            <Button variant="outlined" color="coopinfa" sx={{ width: "100px" }} onClick={() => { props.cerrar() }}>Cancelar</Button>
            <Button variant="contained" color="coopinfa" sx={{ width: "100px" }} onClick={handleConfirmar}>Grabar</Button>
        </DialogActions>
    </Dialog>
}